export { initialZoom, zoomThreshold } from './constantsCamera';

export const themeDark = {
  background: '#0d0d0d',
  polyline: '#ffffff',
  boxFill: '#00bcd4',
  boxOutline: '#00bcd4',
  circleOutline: '#ffeb3b',
  marbleLightness: 75,
} as const;
